<div class="nes-flex nes-flex-col">
  <nes-heading tag="h3" size="base">
    {{ "RECEIPT.MANUAL_ORDER.LABEL" | translate }}
  </nes-heading>
  <nes-text>
    {{ "RECEIPT.MANUAL_ORDER.TEXT" | translate }}
  </nes-text>
  <nes-button compact variant="tertiary" (nesOnClick)="goToDownloadForm()">
    {{ "RECEIPT.MANUAL_ORDER.BUTTON" | translate }}
  </nes-button>
</div>
